import React from 'react'
import injectStyles from 'react-jss'
import moment from 'moment-timezone'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import { LinkExternal } from '../../Components/LinkExternal'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import styles from './styles.js'

import { USER_DOCUMENT_HEADERS } from './options'
import ActionsBlock from './ActionsBlock'

import { updateNmbrsDocument } from '../../Containers/City/Page/Ambasador/gql'
import { showReduxModal, hideReduxModal } from '../../Reducers/UI/actions'
import { useDispatch } from 'react-redux'
import {
  ROLE_DISTRIBUTOR,
  STATUS_DOCUMENT_REJECTED,
} from '../../shared/constants'
import NmbrsModalBody from './ActionModals/NmbrsModalBody'
import RejectModalBody from './ActionModals/RejectModalBody'
import classNames from 'classnames'
import useContractData from './Hooks/useContractData'
import useGermanyPayrollData from './Hooks/useGermanyPayrollData'
import { COUNTRY_CODE } from '../../constants.js'

const UserDocumentsTable = ({
  documents,
  updateUserDocument,
  ambassador,
  isBa,
  setDocuments,
  nmbrsDocument,
  setNmbrsDocument,
  setGermanyContract,
  setGermanyPayroll,
  user,
  classes,
}) => {
  const countryCode = ambassador.city.country.code
  const dispatch = useDispatch()

  const handleCellChange = (value, row, key) => {
    const newDocuments = documents.map(document => {
      return document.id === row.id
        ? {
            ...document,
            [key]: value,
          }
        : document
    })

    setDocuments(newDocuments)
  }
  const showContractData = countryCode == COUNTRY_CODE.GERMANY

  const {
    openContractDataModal,
    contractData,
    onContractDataEdit,
    onContractDataSave,
    onContractDataStatusChange,
    setContractData,
  } = useContractData(ambassador, user, setGermanyContract)
  const [germanyPayrollHook, showPayrollData] = useGermanyPayrollData(
    ambassador,
    user,
    setGermanyPayroll,
  )

  if (contractData && ambassador.role === ROLE_DISTRIBUTOR) {
    setGermanyContract(contractData)
  }

  if (
    showPayrollData &&
    germanyPayrollHook.payrollData &&
    ambassador.role === ROLE_DISTRIBUTOR
  ) {
    setGermanyPayroll(germanyPayrollHook.payrollData)
  }

  const handleStatusChange = async ({ document, input }) => {
    try {
      await updateUserDocument({ input })
      handleCellChange(input.status, document, 'status')
    } catch (error) {
      /* eslint-disable*/
      console.log({ error })
    }
  }

  const onDocumentStatusChange = async ({ document, status, rejectReason }) => {
    const input = { id: document.id, status: status, rejectReason }

    await handleStatusChange({ document, input })
  }

  const onEdit = async row => {
    const newDocuments = documents.map(document => {
      return document.id === row.id
        ? {
            ...document,
            isEdit: true,
          }
        : { ...document, isEdit: document.isEdit }
    })

    setDocuments(newDocuments)
  }

  const onSave = async document => {
    try {
      const actualDocumentData = documents.find(doc => doc.id == document.id)

      await updateUserDocument({
        input: { id: document.id, comment: actualDocumentData.comment },
      })
      const newDocuments = documents.map(doc => {
        return doc.id === document.id
          ? {
              ...document,
              isEdit: false,
            }
          : doc
      })

      setDocuments(newDocuments)
    } catch (error) {}
  }

  const handleNmbrsChange = async ({ document, input, isEdit }) => {
    try {
      await updateNmbrsDocument({ input })
      setNmbrsDocument({ ...document, ...input, isEdit })
    } catch (error) {
      console.log({ error })
    }
  }

  const onNmbrsStatusChange = async ({ document, status, rejectReason }) => {
    const input = { userId: ambassador.id, status, rejectReason }
    await handleNmbrsChange({ document, input })
  }

  const onNmbrsEdit = async row => {
    setNmbrsDocument({ ...nmbrsDocument, isEdit: true })
  }

  const onNmbrsSave = async document => {
    handleNmbrsChange({
      document,
      input: {
        userId: nmbrsDocument.userId,
        comment: document.comment,
      },
      isEdit: false,
    })
  }

  const renderTableCell = ({
    row,
    key,
    type,
    modal,
    onCustomEdit,
    onCustomSave,
    onCustomStatusChange,
    handleCustomEdit,
  }) => {
    switch (type) {
      case 'string':
        return row && row[key] ? (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
            cypress_id={'docNameUploadedUserEmail'}
          >
            {row[key] || '-'}
          </Typography>
        ) : (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
            cypress_id={'docNameUploadedUserEmail'}
          >
            {'-'}
          </Typography>
        )
      case 'url':
        if (row && row.url == 'modal') {
          return (
            <div
              className={classes.nmbrsModalButton}
              onClick={() => modal({ document: row })}
            >
              View
            </div>
          )
        }
        return row && row[key] ? (
          <LinkExternal href={row[key]} target="_blank">
            View
          </LinkExternal>
        ) : (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
              [classes.notProvidedText]: true,
            })}
          >
            {row && row.name === 'First day at work'
              ? 'Expecting the data'
              : 'Not provided'}
          </Typography>
        )
      case 'date':
        return (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
            cypress_id={'updatedDate'}
          >
            {row && row[key]
              ? moment
                  .tz(Number(row[key]), ambassador.city.timezone)
                  .format('YYYY-MM-DD HH:mm')
              : '-'}
          </Typography>
        )

      case 'input':
        return (row && row[key]) || (row && row.isEdit) ? (
          <OutlinedInput
            id={`${row.name}-${key}`}
            value={row[key]}
            disabled={!row.isEdit}
            sx={{
              '& .notchedOutline': {
                border: 'none',
              },
            }}
            multiline={true}
            onChange={event => {
              const { value } = event.target
              if (row.isCustomData) {
                return handleCustomEdit({
                  ...row,
                  comment: value,
                })
              }
              return handleCellChange(value, row, key)
            }}
            classes={{
              input: row.isEdit ? classes.editInput : classes.outlinedInput,
              root: classes.outlinedInputRoot,
            }}
            cypress_id={'internalComment'}
          />
        ) : (
          <Typography
            className={classNames({
              [classes.text]: true,
              [classes.comment]: true,
            })}
            cypress_id={'internalComment'}
          >
            {'-'}
          </Typography>
        )
      case 'actions':
        return row && row[key] !== null && row[key] !== undefined ? (
          <ActionsBlock
            document={row}
            setDocuments={setDocuments}
            onDocumentStatusChange={
              row.isCustomData ? onCustomStatusChange : onDocumentStatusChange
            }
            onReject={() =>
              openRejectModal({
                document: row,
                onCustomStatusChange,
                setCustomDocument: handleCustomEdit,
              })
            }
            onEdit={row.isCustomData ? onCustomEdit : onEdit}
            onSave={row.isCustomData ? onCustomSave : onSave}
          />
        ) : (
          <Typography className={classes.text}>{'-'}</Typography>
        )

      default:
        return <Typography>{row[key]}</Typography>
    }
  }

  const onRejectModalConfirm = ({
    document,
    rejectReason,
    onCustomStatusChange,
  }) => {
    const isCustomData = document.isCustomData
    const input = {
      document,
      status: STATUS_DOCUMENT_REJECTED,
      rejectReason: rejectReason || document.rejectReason,
    }
    if (isCustomData) {
      return onCustomStatusChange(input)
    } else {
      return onDocumentStatusChange(input)
    }
  }

  const openRejectModal = ({
    document,
    setCustomDocument,
    onCustomStatusChange,
  }) => {
    return dispatch(
      showReduxModal({
        children: (
          <RejectModalBody
            document={document}
            onRejectModalConfirm={onRejectModalConfirm}
            setCustomDocument={setCustomDocument}
            handleCellChange={handleCellChange}
            onCustomStatusChange={onCustomStatusChange}
          />
        ),
        confirmLabel: 'Cancel',
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
        hideTitle: true,
        aspect: 'nonScrollable',
      }),
    )
  }

  const openNmbrsModal = ({ document }) => {
    return dispatch(
      showReduxModal({
        children: (
          <NmbrsModalBody
            ambassador={ambassador}
            nmbrsData={nmbrsDocument}
            onClose={() => {
              dispatch(hideReduxModal())
            }}
          />
        ),
        onConfirm: () => dispatch(hideReduxModal()),
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
        hideTitle: true,
        aspect: 'nonScrollable',
      }),
    )
  }

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.table}>
        <TableContainer className={classes.tableContainer}>
          <Table stickyHeader size="medium">
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.tableRow}>
                {USER_DOCUMENT_HEADERS.map((headCell, index) => (
                  <TableCell
                    key={headCell.key}
                    align={
                      index === USER_DOCUMENT_HEADERS.length - 1
                        ? 'center'
                        : 'left'
                    }
                    className={
                      index !== 0
                        ? classes.tableHeaderCell
                        : classes.firstTableHeaderCell
                    }
                  >
                    <Typography className={classes.tableHeadersLabel}>
                      {headCell.label}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {documents &&
                documents.map(row => {
                  return (
                    <TableRow
                      hover={false}
                      tabIndex={-1}
                      key={row.id}
                      className={classes.tableRow}
                    >
                      {USER_DOCUMENT_HEADERS.map(({ key, type }, index) => (
                        <TableCell
                          key={`${key}-${index}`}
                          align={
                            index === USER_DOCUMENT_HEADERS.length - 1
                              ? 'center'
                              : 'left'
                          }
                        >
                          {renderTableCell({ row, key, type })}
                        </TableCell>
                      ))}
                    </TableRow>
                  )
                })}
              {countryCode == 'NL' && isBa ? (
                <TableRow
                  hover={false}
                  tabIndex={-1}
                  className={classes.tableRow}
                >
                  {USER_DOCUMENT_HEADERS.map(({ key, type }, index) => (
                    <TableCell
                      key={`${key}-${index}`}
                      align={
                        index === USER_DOCUMENT_HEADERS.length - 1
                          ? 'center'
                          : 'left'
                      }
                    >
                      {renderTableCell({
                        row: nmbrsDocument,
                        key,
                        type,
                        modal: openNmbrsModal,
                        onCustomEdit: onNmbrsEdit,
                        onCustomSave: onNmbrsSave,
                        onCustomStatusChange: onNmbrsStatusChange,
                        handleCustomEdit: setNmbrsDocument,
                      })}
                    </TableCell>
                  ))}
                </TableRow>
              ) : null}
              {showContractData && (
                <TableRow
                  hover={false}
                  tabIndex={-1}
                  className={classes.tableRow}
                >
                  {USER_DOCUMENT_HEADERS.map(({ key, type }, index) => (
                    <TableCell
                      key={`${key}-${index}`}
                      align={
                        index === USER_DOCUMENT_HEADERS.length - 1
                          ? 'center'
                          : 'left'
                      }
                    >
                      {renderTableCell({
                        row: contractData,
                        key,
                        type,
                        modal: openContractDataModal,
                        onCustomEdit: onContractDataEdit,
                        onCustomSave: onContractDataSave,
                        onCustomStatusChange: onContractDataStatusChange,
                        handleCustomEdit: setContractData,
                      })}
                    </TableCell>
                  ))}
                </TableRow>
              )}
              {showPayrollData && (
                <TableRow
                  hover={false}
                  tabIndex={-1}
                  className={classes.tableRow}
                >
                  {USER_DOCUMENT_HEADERS.map(({ key, type }, index) => (
                    <TableCell
                      key={`${key}-${index}`}
                      align={
                        index === USER_DOCUMENT_HEADERS.length - 1
                          ? 'center'
                          : 'left'
                      }
                    >
                      {renderTableCell({
                        row: germanyPayrollHook.payrollData,
                        key,
                        type,
                        modal: germanyPayrollHook.openPayrollDataModal,
                        onCustomEdit: germanyPayrollHook.onPayrollDataEdit,
                        onCustomSave: germanyPayrollHook.onPayrollDataSave,
                        onCustomStatusChange:
                          germanyPayrollHook.onPayrollDataStatusChange,
                        handleCustomEdit: germanyPayrollHook.setPayrollData,
                      })}
                    </TableCell>
                  ))}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}

export default injectStyles(styles)(UserDocumentsTable)
